import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Link, Button } from '@mui/material';
import { brand } from '../theme';

function Footer() {
  const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.sentinelArclight&pli=1';
  const sleuthNetUrl = 'https://sleuthnet.com/';
  const dashboardUrl = 'https://dashboard.sleuthnet.com/admin/dashboard';

  return (
    <Box sx={{ bgcolor: brand.s1, borderTop: `1px solid ${brand.border}`, py: 4, textAlign: 'center', mt: 'auto' }}>
      <Typography variant="body2" sx={{ color: brand.fg2 }}>
        &copy; {new Date().getFullYear()} Arc Light Technologies API Platform. All rights reserved.
      </Typography>
      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', gap: 3, mb: 3 }}>
        <Link href="https://arclighttech.com/privacy-policy" target="_blank" underline="hover">
          Privacy Policy
        </Link>
        <Link component={RouterLink} to="/faq" underline="hover">
          FAQ
        </Link>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', gap: 1.5 }}>
        <Button href={sleuthNetUrl} target="_blank" variant="outlined" sx={{ minWidth: 130 }}>
          SleuthNet
        </Button>
        <Button href={dashboardUrl} target="_blank" variant="outlined" sx={{ minWidth: 130 }}>
          SN Dashboard
        </Button>
        <Button
          href={playStoreUrl}
          target="_blank"
          sx={{
            height: 56,
            width: 190,
            minWidth: 0,
            borderRadius: '10px',
            background: 'url(https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png)',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            '&:hover': { opacity: 0.85, bgcolor: 'transparent' },
          }}
          aria-label="Get Sentinel on Google Play"
        />
      </Box>
    </Box>
  );
}

export default Footer;
